import { createSelector } from 'reselect'
import createStatusSelector from '../../selectors/createStatusSelector'

export const getId = (state, props) => props.cardContext.id

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getDateIds = (state, props) => {
  return state['view-card'].dates[props.cardContext.id].ids
}

export const getDatesById = (state, props) => {
  return state['view-card'].dates[props.cardContext.id].byId
}

export const getIsLoading = (state, props) => {
  return state['view-card'].dates[props.cardContext.id].isLoading
}

export const getIsLoaded = (state, props) => {
  return state['view-card'].dates[props.cardContext.id].isLoaded
}

export const getDueDate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].dueDate
}

export const getStartDate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].startDate
}

export const getPersonalDateIds = (state, props) => {
  return state.kanbo.personalDates.ids
}

export const getPersonalDatesById = (state, props) => {
  return state.kanbo.personalDates.byId
}

export const datesSelector = createSelector(
  [getId, getDateIds, getDatesById, getPersonalDateIds, getPersonalDatesById, getDueDate, getStartDate],
  (id, dateIds, datesById, personalDateIds, personalDatesById, dueDate, startDate) => {
    const output = dateIds
      .map(dateId => datesById[dateId])
      .concat(
        personalDateIds
          .map(dateId => ({
            ...personalDatesById[dateId],
            isPersonal: true
          }))
          .filter(personalDate => personalDate.cardId === id)
      )

    if (dueDate) {
      output.push(
        {
          timestamp: dueDate,
          isDueDate: true
        }
      )
    }

    if (startDate) {
      output.push(
        {
          timestamp: startDate,
          isStartDate: true
        }
      )
    }

    output.sort((a, b) => a.timestamp - b.timestamp)

    return output
  }
)

export default () => {
  const statusSelector = createStatusSelector(getId)

  return createSelector(
    [
      statusSelector,
      getId,
      getIsArchived,
      datesSelector,
      getIsLoading,
      getIsLoaded
    ],
    (
      status,
      id,
      isArchived,
      dates,
      isLoading,
      isLoaded
    ) => ({
      status,
      id,
      isArchived,
      dates,
      isLoading,
      isLoaded
    })
  )
}
